import { render, staticRenderFns } from "./ChatFilters.vue?vue&type=template&id=15212ba6&scoped=true"
import script from "./ChatFilters.vue?vue&type=script&lang=js"
export * from "./ChatFilters.vue?vue&type=script&lang=js"
import style0 from "./ChatFilters.vue?vue&type=style&index=0&id=15212ba6&prod&scoped=true&lang=scss"
import style1 from "./ChatFilters.vue?vue&type=style&index=1&id=15212ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15212ba6",
  null
  
)

export default component.exports